import { useState } from 'react'
import { Container, Row, Col, Image } from 'react-bootstrap'
import SignUpForm from '../7bs/SignUpForm'

const DiscoverHow = (props) => { 

    const [lgShow, setLgShow] = useState(false);

return (
    <>
    <a name="results-may-vary" id="results-may-vary"></a>
    <div className="section-footer">
        <Container>
            <Image src="../images/7bs/img-arrow-up01.png" alt="" className="img-fluid d-block mx-auto mb-md-5 mb-0 arrow-up"/>
            <Row>
                <Col xl={5} lg={5} md={6}>
                    <h4 className="text-center text-white mb-3">Fill in the form to get the special report for free!</h4>
                    <p><a className="btn btn-free-report" onClick={() => setLgShow(true)}>Give me the FREE Report!</a></p>
                </Col>
                <Col xl={7} lg={7} md={6} className="right-column">
                    <p><strong>Discover how some of Hollywood's biggest stars get in <br className="d-md-block d-none"/>
                        shape and look their best within weeks.</strong></p>
                    <p><strong>We'll reveal the tips and techniques <br className="d-md-block d-none"/>
                        of one of America's most <br className="d-md-block d-none"/>
                        sought-after diet and <br className="d-md-block d-none"/>
                        fitness experts.</strong></p>
                    <Image src="../images/7bs/bg-vegetables01.png" alt="" className="img-fluid d-block mb-3 ml-auto"/>
                </Col>
            </Row>
            <h5 className="mt-3 text-center">*Results May Vary From Person To Person</h5>
        </Container>
    </div>
    <SignUpForm show={lgShow} onHide={() => setLgShow(false)} global={props.global}/>
    <style jsx global>{`

            .section-footer {
                background: #122949;
                color: #96a0b0;
            }

            .section-footer .arrow-up {
                position: relative;
                top: -30px;
            }

            .section-footer .container {
                padding-bottom: 80px;
            }

            .section-footer p {
                font-family: 'Roboto', Helvetica, Arial, sans-serif;
                font-weight: 300;
                font-size: 18px;
            }

            .section-footer .right-column p {
                line-height: 40px;
            }

            .section-footer h4 {
                font-family: 'Roboto', Helvetica, Arial, sans-serif;
                font-weight: 300;
            }

            .section-footer form {
                background: #52c4d2;
                padding: 20px 25px 25px;
                border-radius: 5px;
            }

            .section-footer img {
                max-width: 400px;
            }

        `}</style>
    </>
);
}

export default DiscoverHow;